export const isValidInput = (
  input: string,
  type: "email" | "phone" | "postalCode"
): boolean => {
  if (type === "email") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  } else if (type === "phone") {
    const phoneRegex = /^(?:\+385|0)(?:91|92|95|97|98|99)\d{6,7}$/;
    return phoneRegex.test(input);
  } else {
    // type = postalCode
    const postalCodeRegex = /^\d*$/;
    return postalCodeRegex.test(input);
  }
};
